import declare from "dojo/_base/declare";
import NumberRen from "csi/heading/Number";
import locale from "csi/locale";

const ECNumberRenderer = declare(NumberRen, {
	/**
	 * @override
	 * Throw specific error if the number entered is not correct
	 */
	validateValue(ctx, h, value) {
		if (value > 3 || value < 1){
			throw new Error(locale.resource("INVALID_AVAILABLE_IMPACT_LEVELS_TO_RETRIEVE"));
		}
	},
});

export = ECNumberRenderer;
